import { SCROLL_STRIP_FRAME_CLASS, SCROLL_STRIP_ITEM_CLASS, SCROLL_STRIP_TRACK_CLASS, useScrollStrip } from "../../lib/use-scroll-strip";
import { ServiceCard, ServicesHeading, ServicesSection } from "./services-parts";
import React from "react";
import { ScrollStripArrows } from "../ui/scroll-strip-arrows";
import type { ServicesLayoutProps } from "./services-parts";
import { serviceKey } from "./services-text";

/**
 * The services as cards in one row a visitor swipes through, with arrows on bigger screens.
 * The same scroll engine as the Gallery's scrolling row, so it swipes before any script loads.
 * @param {ServicesLayoutProps} props The section's props.
 * @returns {React.JSX.Element} The section.
 */
const ServicesCarousel = ({ id, className, heading, subheading, services, backgroundColor }: ServicesLayoutProps): React.JSX.Element => {
  const strip = useScrollStrip();
  const { trackRef } = strip;
  const trackId = `${React.useId()}-services`;
  const shown = services ?? [];
  return (
    <ServicesSection id={id} className={className} backgroundColor={backgroundColor}>
      <div className="jobsite:mb-8 jobsite:flex jobsite:items-end jobsite:justify-between jobsite:gap-6 jobsite:md:mb-10">
        <ServicesHeading heading={heading} subheading={subheading} className="jobsite:mx-0 jobsite:mb-0 jobsite:text-left" />
        {shown.length > 1 && <ScrollStripArrows strip={strip} trackId={trackId} itemsLabel="services" />}
      </div>
      <div className={SCROLL_STRIP_FRAME_CLASS}>
        <div id={trackId} ref={trackRef} data-testid="services-carousel" className={SCROLL_STRIP_TRACK_CLASS}>
          {shown.map((service) => (
            <ServiceCard key={serviceKey(service)} service={service} className={SCROLL_STRIP_ITEM_CLASS} />
          ))}
        </div>
      </div>
    </ServicesSection>
  );
};

export { ServicesCarousel };
